import React, { Suspense } from "react";
import {
  HashRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { IsEmpty } from "../utils/helper";
import PrivateRoute from "./PrivateRoutes";

import Login from "../pages/Login/Login";
import HomePage from "../pages/Dashboard/HomePage/HomePageV2";

// DASHBOARDS
import C16AllOrdersDashboard from "../pages/Dashboard/AllOrdersDashboard/C16AllOrdersDashboard";
import F20ExcludeTestOrdersForm from "../pages/Forms/ExcludeTestOrdersForm/F20ExcludeTestOrdersForm"

import C01SupervisorDashboard from "../pages/Dashboard/SupervisorDashboardV2/C01SupervisorDashboardV2";
import C12OrderAnalysisDashboard from "../pages/Dashboard/OrdersAnalysisDashboard/C12OrderAnalysisDashboard";
import C10OrderConfirmationDashboard from "../pages/Dashboard/OrderConfirmationDashboard/C10OrderConfirmationDashboard";
import C05PhotoLabPrintingDashboard from "../pages/Dashboard/PhotoLabPrintingDashboardV3/C05PhotoLabPrintingDashboard";
import C07DigitalPressPrintingDashboard from "../pages/Dashboard/DigitalPressPrintingDashboard/C07DigitalPressPrintingDashboard";
import C08SublimationPrintingDashboard from "../pages/Dashboard/SublimationPrintingDashboardV3/C08SublimationPrintingDashboard";
import PrintSummary from "../pages/Dashboard/SupervisorDashboardV2/BarcodePrintViewV2";
import PrintBarcode from "../pages/Dashboard/SupervisorDashboardV2/BarcodePrintView";
import C11PrintingQADashboard from "../pages/Dashboard/PrintingQADashboard/C11PrintingQADashboard";
import C06QADashboard from "../pages/Dashboard/QADashboardV2/C06QADashboard";
import C09DispatchDashboard from "../pages/Dashboard/DispatchDashboard/C09DispatchDashboard";
import DispatchSalesInvoice from "../pages/Dashboard/DispatchDashboard/Chunks/SalesInvoice";
import C13DeliveryOrdersStatusDashboard from "../pages/Dashboard/DeliveryOrdersStatusDashboard/C13DeliveryOrdersStatusDashboard";

import C14AllOrdersProgressDashboard from "../pages/Dashboard/AllOrdersProgressDashboard/C14AllOrdersProgressDashboard";




// import ExamplePDFViewer from "../pages/Dashboard/ExamplePDFViewer";



// import SearchOrders from "../pages/SearchOrders/SearchOrders";

// FORMS


import F314CallToActionsForm from "../pages/Forms/CallToActionsForm/F314CallToActionsForm";
import F314CallToActionsReport from "../pages/Forms/CallToActionsForm/F314CallToActionsReport";

//import R300DiscountVoucherTableComponent from '../pages/Forms/DiscountVoucherForm/R300DiscountVoucherTableComponent';
import F300DiscountVoucherForm from "../pages/Forms/DiscountVoucherForm/F300DiscountVoucherForm";
import F304PushNotificationForm from "../pages/Forms/PushNotifications/F304PushNotificationForm";
import F300DiscountVoucherReport from "../pages/Forms/DiscountVoucherForm/F300DiscountVoucherReport";
import F304PushNotificationReport from "../pages/Forms/PushNotifications/F304PushNotificationReport";
import F301GeneralDiscountFormV4 from "../pages/Forms/GeneralDiscountForm/F301GeneralDiscountFormV4";
import F301GeneralDiscountReport from "../pages/Forms/GeneralDiscountForm/F301GeneralDiscountReport";
import F302SaleOrderDisputeForm from "../pages/Forms/SaleOrderDispute/F302SaleOrderDisputeForm";
import F303GeneralPricingFormV3 from "../pages/Forms/GeneralPricingForm/F303GeneralPricingFormV3";
import F303GeneralPricingReport from "../pages/Forms/GeneralPricingForm/F303GeneralPricingReport";
import F400InventoryItemForm from "../pages/Forms/InventoryItemForm/F400InventoryItemForm";
import R401InventoryItemView from "../pages/Reports/InventoryItemsView/R401InventoryItemView";
import F402InventoryItemStockForm from "../pages/Forms/InventoryItemStockForm/F402InventoryItemStockForm";
import R403InventoryItemStockView from "../pages/Reports/InventoryItemsStockView/R403InventoryItemStockView";
import F404InventoryItemIssuanceForm from "../pages/Forms/InventoryItemIssuanceForm/F404InventoryItemIssuanceForm";
import R405InventoryItemIssuanceView from "../pages/Reports/InventoryItemsIssuanceView/R405InventoryItemsIssuanceView";


import R406InventoryItemStockSummary from "../pages/Reports/InventoryItemsStockSummary/R406InventoryItemStockSummary";
import F15AllThemedAssetsView from "../pages/Reports/AllThemedAssetsView/F15AllThemedAssetsView";
import F15ThemeProductsAssetsForm from "../pages/Forms/ThemeProductsAssetsForm/F15ThemeProductsAssetsForm";
import F15ThemeProductsAssetsFormWithFolder from "../pages/Forms/ThemeProductsAssetsForm/F15ThemeProductsAssetsFormWithFolder";
import F70Form from "../pages/Forms/UserRights/F70Form";
import C305SaleOrdersRevenueView from "../pages/Reports/AllOrdersRevenue/C305SaleOrdersRevenueView";

const CheckLogin = () => {
  const data = localStorage.getItem("ckAdminUser") || "{}";
  const jsonData = JSON.parse(data) || {};
  if (!IsEmpty(jsonData)) {
    return <Redirect to="/" />;
  } else {
    return <Login />;
  }
};

const Logout = () => {
  localStorage.removeItem("ckAdminUser");
  return <Redirect to="/login" />;
};

const NoFound = () => {
  return <Redirect to="/" />;
};

const AppRoute = () => {
  return (
    <>
      <Router>
        <Suspense fallback={<p>Loading...</p>}>
          <Switch>
            <Route exact path="/login" component={CheckLogin} />
            {/* <Route exact path="/searchOrders" component={SearchOrders} /> */}
            <Route exact path="/logout" component={Logout} />
            <PrivateRoute exact path="/" component={HomePage} />
            {/* <Route exact path="/homepage/:token" component={HomePage} /> */}
            <PrivateRoute
              exact
              path="/C01SupervisorDashboard"
              component={C01SupervisorDashboard}
            />
            <PrivateRoute
              exact
              path="/C16AllOrdersDashboard"
              component={C16AllOrdersDashboard}
            />
            <PrivateRoute
              exact
              path="/F20ExcludeTestOrdersForm"
              component={F20ExcludeTestOrdersForm}
            />

            <PrivateRoute
              exact
              path="/C05PhotoLabPrintingDashboard"
              component={C05PhotoLabPrintingDashboard}
            />
            <PrivateRoute
              exact
              path="/C07DigitalPressPrintingDashboard"
              component={C07DigitalPressPrintingDashboard}
            />
            <PrivateRoute
              exact
              path="/C08SublimationPrintingDashboard"
              component={C08SublimationPrintingDashboard}
            />
            <PrivateRoute
              exact
              path="/C06QADashboard"
              component={C06QADashboard}
            />
            <PrivateRoute
              exact
              path="/C11PrintingQADashboard"
              component={C11PrintingQADashboard}
            />
            <PrivateRoute
              exact
              path="/C09DispatchDashboard"
              component={C09DispatchDashboard}
            />
            <PrivateRoute
              exact
              path="/C10OrderConfirmationDashboard"
              component={C10OrderConfirmationDashboard}
            />

            <PrivateRoute
              exact
              path="/C12OrderAnalysisDashboard"
              component={C12OrderAnalysisDashboard}
            />

            <PrivateRoute
              exact
              path="/C14AllOrdersProgressDashboard"

              component={C14AllOrdersProgressDashboard}
            />
            <PrivateRoute
              exact
              path="/C09DispatchSalesInvoice/:orderId"
              component={DispatchSalesInvoice}
            />
            <PrivateRoute
              exact
              path="/print-barcode"
              component={PrintBarcode}
            />
            <PrivateRoute
              exact
              path="/print-summary"
              component={PrintSummary}
            />
            {/* <PrivateRoute
              exact
              path="/pdf-viewer"
              component={ExamplePDFViewer} */}
            {/* /> */}
            {/* <PrivateRoute exact path ="/R300DiscountVoucherTableComponent" component={R300DiscountVoucherTableComponent} /> */}
            <PrivateRoute
              exact
              path="/F300DiscountVoucherReport"
              component={F300DiscountVoucherReport}
            />
            <PrivateRoute
              exact
              path="/F304PushNotificationReport"
              component={F304PushNotificationReport}
            />


            <PrivateRoute
              exact
              path="/F300DiscountVoucherForm/:recordId"
              component={F300DiscountVoucherForm}
            />
            <PrivateRoute
              exact
              path="/F301GeneralDiscountFormV4/:recordId"
              component={F301GeneralDiscountFormV4}
            />
            <PrivateRoute
              exact
              path="/F301GeneralDiscountReport"
              component={F301GeneralDiscountReport}
            />

            <PrivateRoute
              exact
              path="/F302SaleOrderDisputeForm/:recordId"
              component={F302SaleOrderDisputeForm}
            />
            <PrivateRoute
              exact
              path="/F303GeneralPricingFormV3/:recordId"
              component={F303GeneralPricingFormV3}
            />
            <PrivateRoute
              exact
              path="/F303GeneralPricingReport"
              component={F303GeneralPricingReport}
            />
            <PrivateRoute
              exact
              path="/F304PushNotificationForm/:recordId"
              component={F304PushNotificationForm}
            />
            <PrivateRoute
              exact
              path="/F314CallToActionsReport"
              component={F314CallToActionsReport}
            />
            <PrivateRoute
              exact
              path="/F314CallToActionsForm/:recordId"
              component={F314CallToActionsForm}
            />

            <PrivateRoute
              exact
              path="/F400InventoryItemForm"
              component={F400InventoryItemForm}
            />
            <PrivateRoute
              exact
              path="/R401InventoryItemsView"
              component={R401InventoryItemView}
            />
            <PrivateRoute
              exact
              path="/F402InventoryItemStockForm"
              component={F402InventoryItemStockForm}
            />
            <PrivateRoute
              exact
              path="/R403InventoryItemStockView"
              component={R403InventoryItemStockView}
            />
            <PrivateRoute
              exact
              path="/F404InventoryItemIssuanceForm"
              component={F404InventoryItemIssuanceForm}
            />
            <PrivateRoute
              exact
              path="/R405InventoryItemIssuanceView"
              component={R405InventoryItemIssuanceView}
            />


            <PrivateRoute
              exact
              path="/R406InventoryItemsStockSummary"
              component={R406InventoryItemStockSummary}
            />

            <PrivateRoute
              exact
              path="/F15AllThemedAssetsView"
              component={F15AllThemedAssetsView}
            />
            <PrivateRoute
              exact
              path="/F15ThemeProductsAssetsForm"
              component={F15ThemeProductsAssetsForm}
            />
            <PrivateRoute
              exact
              path="/F15ThemeProductsAssetsFormWithFolder"
              component={F15ThemeProductsAssetsFormWithFolder}
            />
            <PrivateRoute
              exact
              path="/C13DeliveryOrdersStatusDashboard"
              component={C13DeliveryOrdersStatusDashboard}
            />

            <PrivateRoute 
              exact
              path="/C305SaleOrdersRevenueView"
              component={C305SaleOrdersRevenueView}
            />

            <PrivateRoute exact path="/F70Form" component={F70Form} />

            <Route exact path="*" component={NoFound} />
          </Switch>
        </Suspense>
      </Router>
    </>
  );
};

export default AppRoute;
